<app-collapsible-container
    [id]="'generalData'"
    [title]="'REPERTOIRE.FORMS.GENERAL-DATA.TITLE'"
    [icon]="'i-clipboard'"
    (elementSizeModification)="elementSizeModification.emit()"
>
    <ng-container *appCheckPermissions="permissions.repertoire_is_active_switch_change">
        <div *ngIf="isEdit" class="form-control">
            <app-switch-input [formControl]="isActive" [title]="'REPERTOIRE.FORMS.IS-ACTIVE.TITLE'" [readOnly]="readonly">
            </app-switch-input>
        </div>
    </ng-container>

    <div class="form-control">
        <app-generic-radio-checkbox
            *ngIf="userType === entityTypeEnum.SCHOOL"
            [config]="{
                formGroupName: 'educationType',
                inputType: 'radio',
                questionChoices: educationTypesEnum$ | async
            }"
            [formControl]="educationType"
            class="horizontal"
            [readOnly]="readonly"
        >
        </app-generic-radio-checkbox>
    </div>

    <app-generic-radio-checkbox
        *ngIf="userType === entityTypeEnum.CLASS"
        [config]="{
            formGroupName: 'educationLevel',
            inputType: 'radio',
            questionChoices: educationLevelsEnum$ | async
        }"
        [formControl]="educationLevel"
        class="horizontal"
        [readOnly]="readonly"
    >
    </app-generic-radio-checkbox>

    <div class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.GENERAL-DATA.NAME' | translate }}</label>
        <app-basic-input
            [formControl]="name"
            [inputConfig]="{
                placeholder: 'REPERTOIRE.FORMS.GENERAL-DATA.PLACEHOLDERS.NAME',
                inputId: 'name',
                type: basicInputTypeEnum.TEXT
            }"
            [maxLength]="255"
            [isValid]="name.valid"
            [readOnly]="readonly"
            [icons]="entityType === entityTypeEnum.SCHOOL ? 'i-school' : entityType === entityTypeEnum.CLASS ? 'i-class' : 'i-group'"
        >
            <app-form-errors *ngIf="name.touched" [errors]="name.errors" (errorDisplay)="elementSizeModification.emit()"></app-form-errors>
        </app-basic-input>
    </div>

    <div *ngIf="userType === entityTypeEnum.SCHOOL" class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.GENERAL-DATA.EMAIL' | translate }}</label>
        <app-basic-input
            [formControl]="email"
            [inputConfig]="{
                placeholder: 'REPERTOIRE.FORMS.GENERAL-DATA.PLACEHOLDERS.EMAIL',
                inputId: 'email',
                type: basicInputTypeEnum.EMAIL
            }"
            [maxLength]="255"
            [isValid]="email.valid"
            [readOnly]="readonly"
            [icons]="'i-mail'"
        >
            <app-form-errors
                *ngIf="email.touched"
                [errors]="email.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>

    <div *ngIf="userType === entityTypeEnum.SCHOOL" class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.GENERAL-DATA.MOBILE-NUMBER' | translate }}</label>
        <app-basic-input
            *ngIf="formGroup.get('mobileNumber')"
            [formControl]="mobileNumber"
            [inputConfig]="{
                placeholder: 'REPERTOIRE.FORMS.GENERAL-DATA.PLACEHOLDERS.MOBILE-NUMBER',
                inputId: 'mobileNumber',
                type: basicInputTypeEnum.TEXT
            }"
            [maxLength]="16"
            [isValid]="mobileNumber.valid"
            (focusout)="formatPhoneNumber(mobileNumber)"
            [readOnly]="readonly"
            [icons]="'i-mobile'"
        >
            <app-form-errors
                *ngIf="mobileNumber.touched"
                [errors]="mobileNumber.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>

    <div *ngIf="userType === entityTypeEnum.SCHOOL" class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.GENERAL-DATA.HOME-NUMBER' | translate }}</label>
        <app-basic-input
            *ngIf="formGroup.get('homeNumber')"
            [formControl]="homeNumber"
            [inputConfig]="{
                placeholder: 'REPERTOIRE.FORMS.GENERAL-DATA.PLACEHOLDERS.HOME-NUMBER',
                inputId: 'homeNumber',
                type: basicInputTypeEnum.TEXT
            }"
            [maxLength]="15"
            [isValid]="homeNumber.valid"
            (focusout)="formatPhoneNumber(homeNumber)"
            [readOnly]="readonly"
            [icons]="'i-phone'"
        >
            <app-form-errors
                *ngIf="homeNumber.touched"
                [errors]="homeNumber.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>

    <div *ngIf="userType === entityTypeEnum.SCHOOL" class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.GENERAL-DATA.WEBSITE' | translate }}</label>
        <app-basic-input
            [formControl]="website"
            [inputConfig]="{
                placeholder: 'REPERTOIRE.FORMS.GENERAL-DATA.PLACEHOLDERS.WEBSITE',
                inputId: 'website',
                type: basicInputTypeEnum.URL
            }"
            [maxLength]="255"
            [isValid]="website.valid"
            [readOnly]="readonly"
            [icons]="'i-globe'"
        >
            <app-form-errors
                *ngIf="website.touched"
                [errors]="website.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>

    <div *ngIf="userType === entityTypeEnum.SCHOOL" class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.GENERAL-DATA.VAT-NUMBER' | translate }}</label>
        <app-basic-input
            [formControl]="vatNumber"
            [inputConfig]="{
                placeholder: 'REPERTOIRE.FORMS.GENERAL-DATA.PLACEHOLDERS.VAT-NUMBER',
                inputId: 'vatNumber',
                type: basicInputTypeEnum.TEXT
            }"
            [maxLength]="16"
            [isValid]="vatNumber.valid"
            [maskConfig]="vatMaskConfig"
            [readOnly]="readonly"
            [icons]="'i-building'"
        >
        </app-basic-input>
    </div>

    <div *ngIf="userType === entityTypeEnum.SCHOOL" class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.GENERAL-DATA.BANK-ACCOUNT' | translate }}</label>
        <app-basic-input
            [formControl]="bankAccount"
            [inputConfig]="{
                placeholder: 'REPERTOIRE.FORMS.GENERAL-DATA.PLACEHOLDERS.BANK-ACCOUNT',
                inputId: 'bankAccount',
                type: basicInputTypeEnum.TEXT
            }"
            [maxLength]="19"
            [isValid]="bankAccount.valid"
            [maskConfig]="bankAccountMaskConfig"
            [readOnly]="readonly"
            [icons]="'i-credit-card'"
        >
        </app-basic-input>
    </div>

    <div *ngIf="userType === entityTypeEnum.CLASS" class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.GENERAL-DATA.CLASS-TYPE' | translate }}</label>
        <app-generic-select
            [config]="{
                formGroupName: 'classType',
                choices: classTypesChoices$ | async | sortBy: 'label' | filterByEducationLevel: educationLevel.value
            }"
            [formControl]="classType"
            [isValid]="classType.valid"
            [placeholder]="'REPERTOIRE.FORMS.GENERAL-DATA.PLACEHOLDERS.CLASS-TYPE'"
            [readOnly]="readonly"
        >
            <app-form-errors
                *ngIf="classType.touched"
                [errors]="classType.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-generic-select>
    </div>

    <div *ngIf="userType === entityTypeEnum.CLASS" class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.GENERAL-DATA.SCHOOL-YEAR' | translate }}</label>
        <app-generic-select
            [config]="{
                formGroupName: 'schoolYear',
                choices: schoolYears$ | async
            }"
            [formControl]="schoolYear"
            [isValid]="schoolYear.valid"
            [placeholder]="'REPERTOIRE.FORMS.GENERAL-DATA.PLACEHOLDERS.SCHOOL-YEAR'"
            [readOnly]="readonly"
        >
            <app-form-errors
                *ngIf="schoolYear.touched"
                [errors]="schoolYear.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-generic-select>
    </div>
</app-collapsible-container>
